<div class="header">
  <div class="al-page-title">
    <a
      class="al-page-back al-relief-icon al-relief-icon--large al-icon--chevron-left"
      routerLink="/creator"
      [attr.aria-label]="'pages.creator.backToStart' | translate"
      [nbTooltip]="'pages.creator.backToStart' | translate"
      nbTooltipPlacement="right"
    ><span class="al-relief-glyph" aria-hidden="true"></span></a>
    <h2>{{ "pages.creator.library.title" | translate }}</h2>
  </div>
  <div class="header__actions">
    <!-- a <button>: the portal's button look is global on `button[nbButton]` -->
    <button nbButton type="button" status="primary" routerLink="/creator">
      <nb-icon icon="plus-outline"></nb-icon>
      {{ "pages.creator.library.create" | translate }}
    </button>
  </div>
</div>

<app-page-loader *ngIf="state === 'loading'"></app-page-loader>

<nb-card *ngIf="state === 'error'">
  <nb-card-body class="load-error">
    <p>{{ "pages.creator.library.loadError" | translate }}</p>
    <button nbButton status="primary" type="button" (click)="load()">{{ "pages.creator.library.retry" | translate }}</button>
  </nb-card-body>
</nb-card>

<nb-card *ngIf="state === 'ready'">
  <nb-card-body>
    <div class="toolbar">
      <app-segmented-control
        [options]="filters"
        [value]="filter"
        [ariaLabel]="'pages.creator.library.filter.label' | translate"
        (valueChange)="setFilter($event)"
        alAnchor="creator.library-filter"
      ></app-segmented-control>
      <app-segmented-control
        *ngIf="filter === 'courses'"
        class="course-filter"
        [options]="courseFilters"
        [value]="courseKind"
        [ariaLabel]="'pages.creator.library.courseFilter.label' | translate"
        (valueChange)="setCourseKind($event)"
        alAnchor="creator.library-course-filter"
      ></app-segmented-control>
      <span class="toolbar__spacer"></span>
      <app-search-input
        class="toolbar__search"
        [value]="query"
        (valueChange)="onQuery($event)"
        placeholderKey="pages.creator.library.searchPlaceholder"
        alAnchor="creator.library-search"
      ></app-search-input>
      <button nbButton appearance="outline" status="primary" type="button" (click)="openTrash()" alAnchor="creator.trash">
        <nb-icon icon="trash-2-outline"></nb-icon>
        {{ "pages.creator.library.trash" | translate }}
      </button>
    </div>

    <p *ngIf="rows.length === 0" class="empty">
      {{ emptyText }}
    </p>

    <app-table
      *ngIf="rows.length > 0"
      rowIdKey="id"
      agentEntityType="creator_item"
      [nbSpinner]="busy"
      [title]="''"
      [columns]="columns"
      [data]="rows"
      [rowActions]="rowActions"
      [selectable]="false"
      [showPagination]="false"
      [maxVisibleItems]="pageSize"
      (event)="onTableEvent($event)"
    ></app-table>

    <app-pagination
      *ngIf="total > pageSize"
      class="pager"
      [totalItems]="total"
      [itemsPerPage]="pageSize"
      [currentPage]="page"
      [pageSizeOptions]="pageSizes"
      (pageChanged)="setPage($event)"
    ></app-pagination>
  </nb-card-body>
</nb-card>
